const config = {
    PAGE_URL: "https://haxstats.litoralsoftware.com",
    API_URL: "https://api-haxstats.litoralsoftware.com",
    // API_URL: "http://localhost:5000",
    COUNTRY_API_URL: "https://api.first.org/data/v1/countries?limit=249",
    pageName: "HaxStats",
    pageDescription: "¡Visualizá estadisticas de jugadores Haxball acá! Sumate a jugar con nuestro bot y sumar puntos en nuestro ranking.",
    titleSeparator: "| HaxStats",
}

export default config
